<div rds-dialog-header>
  <h2 rds-dialog-title>Assigned users</h2>
</div>
<div rds-dialog-content class="dialog-form">
  <div class="contributor">
    @if (data.ownerEmail) {
      <rds-avatar size="m" disableInteractions="true">
        <span rds-avatar-initials>{{
          data.ownerEmail | slice: 0 : 2 | uppercase
        }}</span>
        <rds-avatar-label>{{ data.ownerEmail }}</rds-avatar-label>
        <rds-avatar-description>Owner</rds-avatar-description>
      </rds-avatar>
    }
  </div>

  <div class="contributor">
    @if (data.deputyEmail) {
      <rds-avatar size="m" disableInteractions="true">
        <span rds-avatar-initials>{{
          data.deputyEmail | slice: 0 : 2 | uppercase
        }}</span>
        <rds-avatar-label>{{ data.deputyEmail }}</rds-avatar-label>
        <rds-avatar-description>Deputy</rds-avatar-description>
      </rds-avatar>
    }
  </div>

  @for (author of data.authorEmails; track author) {
    <div class="contributor">
      <rds-avatar size="m" disableInteractions="true">
        <span rds-avatar-initials>{{ author | slice: 0 : 2 | uppercase }}</span>
        <rds-avatar-label>{{ author }}</rds-avatar-label>
        <rds-avatar-description>Author</rds-avatar-description>
      </rds-avatar>
    </div>
  }
</div>
<div rds-dialog-actions-container>
  <button rds-secondary-button [rds-dialog-close]="'No'" size="m">
    Cancel
  </button>
</div>
